// extracted by mini-css-extract-plugin
module.exports = {"GetGift":"GetGift_GetGift__wRVSt"};